import React from 'react';

var PhoneIcon = function PhoneIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), React.createElement("rect", {
    "data-name": "Rechteck 320",
    width: "19.918",
    height: "19.918",
    fill: "none"
  }), React.createElement("path", {
    "data-name": "Pfad 110",
    d: "M11.607,14.286l2.143-1.964a.656.656,0,0,1,.536-.179l.357.179,5,2.321c.357.179.357.357.357.714a4.527,4.527,0,0,1-1.429,3.214A5.115,5.115,0,0,1,14.821,20a10.881,10.881,0,0,1-5-1.25,23.409,23.409,0,0,1-5-3.571A30.416,30.416,0,0,1,2.143,11.25,24.683,24.683,0,0,1,.357,7.321,10.989,10.989,0,0,1,0,3.929,4.692,4.692,0,0,1,1.25,1.25,5.431,5.431,0,0,1,4.643,0a.928.928,0,0,1,.714.357l2.679,5a.623.623,0,0,0,.179.357.656.656,0,0,1-.179.536L5.714,8.393a.8.8,0,0,0,0,.893,17.053,17.053,0,0,0,2.143,2.857,18.03,18.03,0,0,0,2.857,2.321C11.071,14.643,11.429,14.643,11.607,14.286Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }));
};

export default PhoneIcon;